export * from '../models/Account';
export * from '../models/AccountIdFilters';
export * from '../models/AccountState';
export * from '../models/AccountUpdateInput';
export * from '../models/AccountsResponse';
export * from '../models/ActionFilters';
export * from '../models/ActivateAwsOrganizationResponse';
export * from '../models/ActivateSourceAccountResponse';
export * from '../models/Ami';
export * from '../models/AmiBlockDevice';
export * from '../models/ApiCredentials';
export * from '../models/ApiCredentialsProperties';
export * from '../models/App';
export * from '../models/AppFilters';
export * from '../models/ApplicationOverride';
export * from '../models/AppsDetails';
export * from '../models/AtlasProject';
export * from '../models/AtlasProjects';
export * from '../models/AuditLog';
export * from '../models/AuditLogAction';
export * from '../models/AuditLogEntitiesInner';
export * from '../models/AuditLogFilterConditions';
export * from '../models/AuthParams';
export * from '../models/AuthResponse';
export * from '../models/AwsDatabaseDestination';
export * from '../models/AwsDynamoDBDestination';
export * from '../models/AwsEbsVolumeRestoreData';
export * from '../models/AwsEc2Resource';
export * from '../models/AwsEc2SnapshotProperties';
export * from '../models/AwsEksNamespaceResource';
export * from '../models/AwsEksNamespaceSnapshotProperties';
export * from '../models/AwsOrganization';
export * from '../models/AwsRdsResource';
export * from '../models/AwsRdsResourceStorageSettings';
export * from '../models/AzureAksNamespaceResource';
export * from '../models/AzureAppIdResponse';
export * from '../models/AzureConnectAccountRequest';
export * from '../models/AzureConnectAccountTerraformRequest';
export * from '../models/AzureConnectionIdResponse';
export * from '../models/AzureConsentUrlResponse';
export * from '../models/AzureDiskRestoreData';
export * from '../models/AzureListResourceGroupsResponse';
export * from '../models/AzureListSubscriptionsResponse';
export * from '../models/AzureManagementGroup';
export * from '../models/AzureManagementGroups';
export * from '../models/AzureMarketplaceWebhookInput';
export * from '../models/AzureMarketplaceWebhookInputSubscription';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
export * from '../models/AzureMssqlSnapshotProperties';
export * from '../models/AzureOnboardingRequest';
export * from '../models/AzureOnboardingStatus';
export * from '../models/AzureOnboardingStatusResponse';
export * from '../models/AzureResourceGroup';
export * from '../models/AzureResourceGroups';
export * from '../models/AzureScanningAccountSetupStatus200Response';
export * from '../models/AzureStorageAccount';
export * from '../models/AzureStorageAccounts';
export * from '../models/AzureSubscription';
export * from '../models/AzureTenant';
export * from '../models/AzureVmDisk';
export * from '../models/AzureVmSnapshotProperties';
export * from '../models/BackedUpByResourceType';
export * from '../models/BackedUpByResourceTypeDataInner';
export * from '../models/BackedUpStorageDateHistogram';
export * from '../models/BackupControlViolations';
export * from '../models/BackupJob';
export * from '../models/BackupJobResponse';
export * from '../models/BackupJobSortField';
export * from '../models/BackupJobType';
export * from '../models/BackupJobsFilterConditions';
export * from '../models/BackupPoliciesFilters';
export * from '../models/BackupPoliciesSecurityConfig';
export * from '../models/BackupPolicy';
export * from '../models/BackupPolicyAppliesNotificationArguments';
export * from '../models/BackupPolicyNotificationArguments';
export * from '../models/BackupPolicySecurityConfig';
export * from '../models/BackupPolicyType';
export * from '../models/BackupRegionsFilters';
export * from '../models/BackupSchedule';
export * from '../models/BackupStatus';
export * from '../models/BackupStatusFilters';
export * from '../models/BackupVault';
export * from '../models/BatchApplicationOverrides';
export * from '../models/BatchOperationResponse';
export * from '../models/BooleanFilters';
export * from '../models/CancelExclusionFromBackupResponse';
export * from '../models/CheckAzureVMNameExists200Response';
export * from '../models/CheckAzureVMNameExistsRequest';
export * from '../models/Classifications';
export * from '../models/CloudAccountConfiguration';
export * from '../models/CloudAccountConfigurationAwsConfigInner';
export * from '../models/CloudAccountConfigurationAwsSecurityGroup';
export * from '../models/CloudAccountConfigurationAwsSubnet';
export * from '../models/CloudAccountConfigurationInput';
export * from '../models/CloudAccountNotificationArguments';
export * from '../models/CloudAccountType';
export * from '../models/CloudRegion';
export * from '../models/CloudResourceConfiguration';
export * from '../models/CloudResourceSecurityProperties';
export * from '../models/CloudSnapshotsPerVolume';
export * from '../models/ClusterNameFilters';
export * from '../models/ColumnMetadata';
export * from '../models/Condition';
export * from '../models/ConditionOperatorEnum';
export * from '../models/ConnectAwsOrganizationRequest';
export * from '../models/ConnectAwsOrganizationResponse';
export * from '../models/ConnectSourceAccountRequest';
export * from '../models/ConnectSourceAccountResponse';
export * from '../models/Control';
export * from '../models/ControlRules';
export * from '../models/ControlViolation';
export * from '../models/ControlViolations';
export * from '../models/ControlViolationsPerSeverity';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner';
export * from '../models/ControlsFilters';
export * from '../models/ConvertEbsSnapshotConfig';
export * from '../models/ConvertEc2ImageConfig';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
export * from '../models/ConvertResourceSnapshotsRequest';
export * from '../models/ConvertResourceSnapshotsResponse';
export * from '../models/CreateAccountInput';
export * from '../models/CreateApiCredentialsRequest';
export * from '../models/CreateApiCredentialsResponse';
export * from '../models/CreateBackupJobInput';
export * from '../models/CreateBackupVaultInput';
export * from '../models/CreatePolicyInput';
export * from '../models/CreatePolicyScheduleInput';
export * from '../models/CreateProjectInput';
export * from '../models/CreateRoleInput';
export * from '../models/CreateSamlIdentityProviderConfigInput';
export * from '../models/CreateScanJobInput';
export * from '../models/CreateScanningApp200Response';
export * from '../models/CreateUserInput';
export * from '../models/CustomTagsInner';
export * from '../models/DBResourceMetadata';
export * from '../models/DBServerRecord';
export * from '../models/DBSnapshotMetadata';
export * from '../models/DBSnapshotType';
export * from '../models/DailySnapshotData';
export * from '../models/DailyStorageSummaries';
export * from '../models/DailyStorageSummary';
export * from '../models/DataAccessRule';
export * from '../models/DataClass';
export * from '../models/DataClassesDetails';
export * from '../models/DataClassesFilters';
export * from '../models/DataClassificationEntity';
export * from '../models/DatabaseDestination';
export * from '../models/DatabaseRecord';
export * from '../models/DeactivateAwsOrganizationResponse';
export * from '../models/DeactivateSourceAccountResponse';
export * from '../models/DestinationDetails';
export * from '../models/DestinationProviderAttributes';
export * from '../models/DestinationProviderAttributesAzure';
export * from '../models/DestinationRestoreTypeAttributes';
export * from '../models/DiscoveryInvokeParams';
export * from '../models/DiscoveryJob';
export * from '../models/DiscoveryStatusResponse';
export * from '../models/DriftProtectionPolicy';
export * from '../models/DriftProtectionSummary';
export * from '../models/DriftProtectionTimePoint';
export * from '../models/EksCluster';
export * from '../models/EksClusterStatus';
export * from '../models/EksNamespaceRestoreDestination';
export * from '../models/EncryptionKey';
export * from '../models/EncryptionKeys';
export * from '../models/Environment';
export * from '../models/EnvironmentDetails';
export * from '../models/EnvironmentFilters';
export * from '../models/EonAccount';
export * from '../models/ExcludeFromBackupResponse';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
export * from '../models/FileExplorerResponse';
export * from '../models/FilePath';
export * from '../models/FileRestoreData';
export * from '../models/FileSearchRecord';
export * from '../models/FileSnapshot';
export * from '../models/GCSBucket';
export * from '../models/GCSBuckets';
export * from '../models/GCSRestoreDestination';
export * from '../models/GCSRestoreTarget';
export * from '../models/GcpCloudSqlResource';
export * from '../models/GcpCloudSqlResourceStorageSettings';
export * from '../models/GcpCloudSqlSnapshotProperties';
export * from '../models/GcpDiskRestoreData';
export * from '../models/GcpDiskSnapshotProperties';
export * from '../models/GcpDiskTypesResponse';
export * from '../models/GcpEncryptionKey';
export * from '../models/GcpEncryptionKeys';
export * from '../models/GcpGkeNamespaceResource';
export * from '../models/GcpMachineTypesResponse';
export * from '../models/GcpSubnet';
export * from '../models/GcpVmResource';
export * from '../models/GcpVmSnapshotProperties';
export * from '../models/GenericSnapshotData';
export * from '../models/GetAWSStackDetailsResponse';
export * from '../models/GetCloudResourceSecurityPropertiesResponse';
export * from '../models/GetResourceResponse';
export * from '../models/GetScanningApp200Response';
export * from '../models/GetSnapshotResponse';
export * from '../models/GroupToRoleMapping';
export * from '../models/IDs';
export * from '../models/IdFilters';
export * from '../models/Identifier';
export * from '../models/InfectedDataByClassification';
export * from '../models/InfectedDataClassificationSize';
export * from '../models/InfectedDataOverTime';
export * from '../models/InfectedDateSize';
export * from '../models/InfectedResourcesCountResponse';
export * from '../models/InitAuthInput';
export * from '../models/Initiator';
export * from '../models/InitiatorNameFilters';
export * from '../models/InventoryFilterConditions';
export * from '../models/InventoryGcpDisk';
export * from '../models/InventoryResource';
export * from '../models/InventoryResourceMetadata';
export * from '../models/InventorySnapshotVolume';
export * from '../models/InventoryVault';
export * from '../models/InventoryVolume';
export * from '../models/IssueMutedNotificationArguments';
export * from '../models/JobExecutionDetails';
export * from '../models/JobSnapshotDetails';
export * from '../models/JobStatus';
export * from '../models/JobStatusFilters';
export * from '../models/KubeAccessStatus';
export * from '../models/KubernetesAccessMode';
export * from '../models/ListAccountsResponse';
export * from '../models/ListApiCredentialsResponse';
export * from '../models/ListApplicationOverrideResponse';
export * from '../models/ListAuditLogRequest';
export * from '../models/ListAuditLogResponse';
export * from '../models/ListAuditLogsResponse';
export * from '../models/ListAwsOrganizationsResponse';
export * from '../models/ListAzureRegions200Response';
export * from '../models/ListAzureSKUs200Response';
export * from '../models/ListAzureSKUs200ResponseSkusInner';
export * from '../models/ListAzureSKUsRequest';
export * from '../models/ListAzureStorageAccountContainers200Response';
export * from '../models/ListAzureStorageAccountContainersRequest';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest';
export * from '../models/ListBackupJobTypesResponse';
export * from '../models/ListBackupJobsInternal200Response';
export * from '../models/ListBackupJobsRequest';
export * from '../models/ListBackupJobsResponse';
export * from '../models/ListBackupPolicyResponse';
export * from '../models/ListBackupVaultResponse';
export * from '../models/ListCloudSnapshotsResponse';
export * from '../models/ListControlViolationsResponse';
export * from '../models/ListControlsResponse';
export * from '../models/ListDailySnapshotsResponse';
export * from '../models/ListDataClassificationEntitiesResponse';
export * from '../models/ListDatabaseSnapshotsResponse';
export * from '../models/ListEksClustersResponse';
export * from '../models/ListGcpSubnetsResponse';
export * from '../models/ListInstanceProfilesResponse';
export * from '../models/ListInstanceTypesResponse';
export * from '../models/ListInventoryAppsResponse';
export * from '../models/ListInventoryBackupRegionsResponse';
export * from '../models/ListInventoryEnvironmentsResponse';
export * from '../models/ListInventoryItemSnapshotsResponse';
export * from '../models/ListInventoryNetworksResponse';
export * from '../models/ListInventoryRequest';
export * from '../models/ListInventoryResourceGroupsResponse';
export * from '../models/ListInventoryResourceIdentifiersResponse';
export * from '../models/ListInventoryResourceTypesResponse';
export * from '../models/ListInventoryResourcesResponse';
export * from '../models/ListInventorySnapshotsRequest';
export * from '../models/ListInventorySnapshotsResponse';
export * from '../models/ListInventorySourceRegionsResponse';
export * from '../models/ListInventorySubnetsResponse';
export * from '../models/ListInventoryTagsResponse';
export * from '../models/ListNotificationPoliciesResponse';
export * from '../models/ListNotificationsResponse';
export * from '../models/ListObjectStoreExclusionRulesResponse';
export * from '../models/ListProjectsResponse';
export * from '../models/ListResourcesResponse';
export * from '../models/ListRestoreAccountsResponse';
export * from '../models/ListRestoreJobTypesResponse';
export * from '../models/ListRestoreJobsInternal200Response';
export * from '../models/ListRestoreJobsRequest';
export * from '../models/ListRestoreJobsResponse';
export * from '../models/ListScanJobsRequest';
export * from '../models/ListScanJobsResponse';
export * from '../models/ListSubnetsResponse';
export * from '../models/ListSubnetsResponseV2';
export * from '../models/ListSubnetsResponseV2SubnetsInner';
export * from '../models/ListUsersResponse';
export * from '../models/MaxRetentionRule';
export * from '../models/Message';
export * from '../models/MinRetentionRule';
export * from '../models/ModelError';
export * from '../models/Notification';
export * from '../models/NotificationArguments';
export * from '../models/NotificationArgumentsRestoreJobFailed';
export * from '../models/NotificationArgumentsRestoreJobSucceeded';
export * from '../models/NotificationPolicy';
export * from '../models/NotificationPolicyConfig';
export * from '../models/NotificationPolicyConfigEmail';
export * from '../models/NotificationPolicyConfigSlack';
export * from '../models/NotificationPolicyConfigSns';
export * from '../models/NotificationPolicyConfigSplunk';
export * from '../models/NotificationStatus';
export * from '../models/NotificationType';
export * from '../models/NumberOfCopiesRule';
export * from '../models/ObjectStorageDestination';
export * from '../models/ObjectStoreExclusionRule';
export * from '../models/OnboardingAzureResourceGroup';
export * from '../models/OperationIdFilters';
export * from '../models/OverrideDataClassificationsRequest';
export * from '../models/OverrideDataClassificationsResponse';
export * from '../models/OverrideEnvironmentRequest';
export * from '../models/OverrideEnvironmentResponse';
export * from '../models/Pagination';
export * from '../models/PartialRestoreData';
export * from '../models/PartialRestoreType';
export * from '../models/Path';
export * from '../models/PathSnapshotsRequest';
export * from '../models/PathSnapshotsResponse';
export * from '../models/PathType';
export * from '../models/PersistentVolumeClaimProperties';
export * from '../models/Preferences';
export * from '../models/Project';
export * from '../models/Provider';
export * from '../models/QueryDBRequest';
export * from '../models/QueryDBResponse';
export * from '../models/QueryDBRestoreDestination';
export * from '../models/QueryDBRestoreDestinationType';
export * from '../models/QueryDBResultResponse';
export * from '../models/QueryDBStatus';
export * from '../models/QueryDBStatusResponse';
export * from '../models/RansomwareResourceNotificationArguments';
export * from '../models/RansomwareSnapshotNotificationArguments';
export * from '../models/RegisterInput';
export * from '../models/RegisterInputBillingToken';
export * from '../models/RegisterResponse';
export * from '../models/RequestDetails';
export * from '../models/ResourceDetails';
export * from '../models/ResourceIdFilters';
export * from '../models/ResourceIdentifiers';
export * from '../models/ResourceNameFilters';
export * from '../models/ResourceProperties';
export * from '../models/ResourceSnapshot';
export * from '../models/ResourceSnapshotProperties';
export * from '../models/ResourceSortField';
export * from '../models/ResourceTag';
export * from '../models/ResourceType';
export * from '../models/ResourceTypeFilters';
export * from '../models/RestoreAccount';
export * from '../models/RestoreAccountRegions';
export * from '../models/RestoreAtlasClusterInput';
export * from '../models/RestoreAvailabilityZones';
export * from '../models/RestoreAzureDiskConfig';
export * from '../models/RestoreAzureDiskInput';
export * from '../models/RestoreAzureMssqlInput';
export * from '../models/RestoreAzureVMInput';
export * from '../models/RestoreAzureVMInstanceConfig';
export * from '../models/RestoreBucketRequest';
export * from '../models/RestoreDbToRdsInstanceRequest';
export * from '../models/RestoreDbToRdsSnapshotRequest';
export * from '../models/RestoreDynamoDBTableInput';
export * from '../models/RestoreDynamoDbTableConfig';
export * from '../models/RestoreEbsVolumeConfig';
export * from '../models/RestoreEc2InstanceConfig';
export * from '../models/RestoreEksNamespaceConfig';
export * from '../models/RestoreEksNamespaceInput';
export * from '../models/RestoreEksNamespaceVolumeInput';
export * from '../models/RestoreFilesRequest';
export * from '../models/RestoreGceDiskConfig';
export * from '../models/RestoreGceInstanceConfig';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig';
export * from '../models/RestoreGcpCloudSqlInput';
export * from '../models/RestoreGcpDiskInput';
export * from '../models/RestoreGcpVMInput';
export * from '../models/RestoreImageImageDeviceInput';
export * from '../models/RestoreImageImageInput';
export * from '../models/RestoreImageInput';
export * from '../models/RestoreImageVolumeInput';
export * from '../models/RestoreInstanceImageDeviceInput';
export * from '../models/RestoreInstanceImageInput';
export * from '../models/RestoreInstanceInput';
export * from '../models/RestoreInstanceVolumeInput';
export * from '../models/RestoreJob';
export * from '../models/RestoreJobConfiguration';
export * from '../models/RestoreJobInitiationResponse';
export * from '../models/RestoreJobSortField';
export * from '../models/RestoreJobType';
export * from '../models/RestoreJobsFilterConditions';
export * from '../models/RestoreRdsInstanceConfig';
export * from '../models/RestoreRdsSubnetGroups';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
export * from '../models/RestoreSecurityGroups';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner';
export * from '../models/RestoreVolumeToEbsRequest';
export * from '../models/RestoreVolumeToEbsSnapshotRequest';
export * from '../models/Role';
export * from '../models/RolesResponse';
export * from '../models/S3Bucket';
export * from '../models/S3Buckets';
export * from '../models/S3RestoreDestination';
export * from '../models/S3RestoreTarget';
export * from '../models/SamlIdentityProvider';
export * from '../models/SamlIdentityProviderConfigsResponse';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest';
export * from '../models/ScanJob';
export * from '../models/ScheduleMode';
export * from '../models/SchemaRecord';
export * from '../models/SearchDBResponse';
export * from '../models/SearchFilesResponse';
export * from '../models/SearchInput';
export * from '../models/SecurityAssignmentStatus';
export * from '../models/SecurityInformation';
export * from '../models/SecurityPlan';
export * from '../models/SecurityPlanEnabledResponse';
export * from '../models/SecurityScan';
export * from '../models/SecurityScanExample';
export * from '../models/SecurityScanResult';
export * from '../models/SecurityScansSummaryResponse';
export * from '../models/SecuritySummary';
export * from '../models/ServiceProviderDetails';
export * from '../models/Severity';
export * from '../models/SeverityFilters';
export * from '../models/Snapshot';
export * from '../models/SnapshotFilterConditions';
export * from '../models/SnapshotLocation';
export * from '../models/SnapshotStatus';
export * from '../models/SnapshotStatusFilters';
export * from '../models/SnapshotStorage';
export * from '../models/SortBackupJobBy';
export * from '../models/SortLogsBy';
export * from '../models/SortOrder';
export * from '../models/SortResourceBy';
export * from '../models/SortRestoreJobBy';
export * from '../models/SourceAccount';
export * from '../models/SourceAccountConfiguration';
export * from '../models/SourceAccountConfigurationUpdateInput';
export * from '../models/SourceRegionFilters';
export * from '../models/SourceStorage';
export * from '../models/SourceStorageBackupStatus';
export * from '../models/SsoIntegrationSettings';
export * from '../models/StatusCodeFilters';
export * from '../models/StorageAccountContainerRestoreDestination';
export * from '../models/StorageAccountRestoreTarget';
export * from '../models/SubnetFilters';
export * from '../models/TableRecord';
export * from '../models/TagKeyValuesFilters';
export * from '../models/TagKeysFilters';
export * from '../models/TokenResponse';
export * from '../models/UnifiedDBRecord';
export * from '../models/UnifiedDBServerRecord';
export * from '../models/UnifiedDatabaseRecord';
export * from '../models/UnifiedSchemaRecord';
export * from '../models/UnifiedTableRecord';
export * from '../models/UpdateAccountInput';
export * from '../models/UpdateApiCredentialsRequest';
export * from '../models/UpdateBackupVaultNameInput';
export * from '../models/UpdateCloudResourceConfigurationRequest';
export * from '../models/UpdateControlViolationInput';
export * from '../models/UpdateResourceSecurityScansExclusionRequest';
export * from '../models/UpdateRoleInput';
export * from '../models/UpdateSamlIdentityProviderInput';
export * from '../models/UpdateShouldFullBackupResourceRequest';
export * from '../models/UpdateUserInput';
export * from '../models/UpdateViewerRoleRequest';
export * from '../models/User';
export * from '../models/UserIdFilters';
export * from '../models/VaultFilters';
export * from '../models/VaultNotificationArguments';
export * from '../models/Viewer';
export * from '../models/ViolationsDetectionNotificationArguments';
export * from '../models/VirtualMachineRestoreDestination';
export * from '../models/VisualizationHistogramSeries';
export * from '../models/VisualizationHistogramTimePoint';
export * from '../models/VisualizationLabel';
export * from '../models/VolumeSettings';
export * from '../models/VpcPropertyFilters';

import { Account } from '../models/Account';
import { AccountIdFilters } from '../models/AccountIdFilters';
import { AccountState } from '../models/AccountState';
import { AccountUpdateInput } from '../models/AccountUpdateInput';
import { AccountsResponse } from '../models/AccountsResponse';
import { ActionFilters } from '../models/ActionFilters';
import { ActivateAwsOrganizationResponse } from '../models/ActivateAwsOrganizationResponse';
import { ActivateSourceAccountResponse } from '../models/ActivateSourceAccountResponse';
import { Ami } from '../models/Ami';
import { AmiBlockDevice } from '../models/AmiBlockDevice';
import { ApiCredentials } from '../models/ApiCredentials';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties';
import { App } from '../models/App';
import { AppFilters } from '../models/AppFilters';
import { ApplicationOverride } from '../models/ApplicationOverride';
import { AppsDetails } from '../models/AppsDetails';
import { AtlasProject } from '../models/AtlasProject';
import { AtlasProjects } from '../models/AtlasProjects';
import { AuditLog } from '../models/AuditLog';
import { AuditLogAction } from '../models/AuditLogAction';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions';
import { AuthParams } from '../models/AuthParams';
import { AuthResponse } from '../models/AuthResponse';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData';
import { AwsEc2Resource } from '../models/AwsEc2Resource';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties';
import { AwsOrganization } from '../models/AwsOrganization';
import { AwsRdsResource } from '../models/AwsRdsResource';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource';
import { AzureAppIdResponse } from '../models/AzureAppIdResponse';
import { AzureConnectAccountRequest, AzureConnectAccountRequestAccountTypeEnum } from '../models/AzureConnectAccountRequest';
import { AzureConnectAccountTerraformRequest, AzureConnectAccountTerraformRequestAccountTypeEnum } from '../models/AzureConnectAccountTerraformRequest';
import { AzureConnectionIdResponse } from '../models/AzureConnectionIdResponse';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse';
import { AzureManagementGroup } from '../models/AzureManagementGroup';
import { AzureManagementGroups } from '../models/AzureManagementGroups';
import { AzureMarketplaceWebhookInput, AzureMarketplaceWebhookInputActionEnum, AzureMarketplaceWebhookInputStatusEnum, AzureMarketplaceWebhookInputOperationRequestSourceEnum } from '../models/AzureMarketplaceWebhookInput';
import { AzureMarketplaceWebhookInputSubscription, AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum, AzureMarketplaceWebhookInputSubscriptionSessionModeEnum, AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum, AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum } from '../models/AzureMarketplaceWebhookInputSubscription';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
import { AzureMarketplaceWebhookInputSubscriptionTerm, AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties';
import { AzureOnboardingRequest, AzureOnboardingRequestAccountTypeEnum } from '../models/AzureOnboardingRequest';
import { AzureOnboardingStatus } from '../models/AzureOnboardingStatus';
import { AzureOnboardingStatusResponse } from '../models/AzureOnboardingStatusResponse';
import { AzureResourceGroup } from '../models/AzureResourceGroup';
import { AzureResourceGroups } from '../models/AzureResourceGroups';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response';
import { AzureStorageAccount } from '../models/AzureStorageAccount';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts';
import { AzureSubscription } from '../models/AzureSubscription';
import { AzureTenant } from '../models/AzureTenant';
import { AzureVmDisk } from '../models/AzureVmDisk';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram';
import { BackupControlViolations } from '../models/BackupControlViolations';
import { BackupJob } from '../models/BackupJob';
import { BackupJobResponse } from '../models/BackupJobResponse';
import { BackupJobSortField } from '../models/BackupJobSortField';
import { BackupJobType } from '../models/BackupJobType';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig';
import { BackupPolicy } from '../models/BackupPolicy';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig';
import { BackupPolicyType } from '../models/BackupPolicyType';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters';
import { BackupSchedule } from '../models/BackupSchedule';
import { BackupStatus } from '../models/BackupStatus';
import { BackupStatusFilters } from '../models/BackupStatusFilters';
import { BackupVault } from '../models/BackupVault';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides';
import { BatchOperationResponse } from '../models/BatchOperationResponse';
import { BooleanFilters } from '../models/BooleanFilters';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest';
import { Classifications } from '../models/Classifications';
import { CloudAccountConfiguration } from '../models/CloudAccountConfiguration';
import { CloudAccountConfigurationAwsConfigInner } from '../models/CloudAccountConfigurationAwsConfigInner';
import { CloudAccountConfigurationAwsSecurityGroup } from '../models/CloudAccountConfigurationAwsSecurityGroup';
import { CloudAccountConfigurationAwsSubnet } from '../models/CloudAccountConfigurationAwsSubnet';
import { CloudAccountConfigurationInput } from '../models/CloudAccountConfigurationInput';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments';
import { CloudAccountType } from '../models/CloudAccountType';
import { CloudRegion } from '../models/CloudRegion';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume';
import { ClusterNameFilters } from '../models/ClusterNameFilters';
import { ColumnMetadata } from '../models/ColumnMetadata';
import { Condition } from '../models/Condition';
import { ConditionOperatorEnum } from '../models/ConditionOperatorEnum';
import { ConnectAwsOrganizationRequest } from '../models/ConnectAwsOrganizationRequest';
import { ConnectAwsOrganizationResponse } from '../models/ConnectAwsOrganizationResponse';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse';
import { Control } from '../models/Control';
import { ControlRules } from '../models/ControlRules';
import { ControlViolation } from '../models/ControlViolation';
import { ControlViolations } from '../models/ControlViolations';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner';
import { ControlsFilters } from '../models/ControlsFilters';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse';
import { CreateAccountInput } from '../models/CreateAccountInput';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse';
import { CreateBackupJobInput } from '../models/CreateBackupJobInput';
import { CreateBackupVaultInput } from '../models/CreateBackupVaultInput';
import { CreatePolicyInput } from '../models/CreatePolicyInput';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput';
import { CreateProjectInput } from '../models/CreateProjectInput';
import { CreateRoleInput } from '../models/CreateRoleInput';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput';
import { CreateScanJobInput } from '../models/CreateScanJobInput';
import { CreateScanningApp200Response } from '../models/CreateScanningApp200Response';
import { CreateUserInput } from '../models/CreateUserInput';
import { CustomTagsInner } from '../models/CustomTagsInner';
import { DBResourceMetadata } from '../models/DBResourceMetadata';
import { DBServerRecord } from '../models/DBServerRecord';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata';
import { DBSnapshotType } from '../models/DBSnapshotType';
import { DailySnapshotData } from '../models/DailySnapshotData';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries';
import { DailyStorageSummary } from '../models/DailyStorageSummary';
import { DataAccessRule } from '../models/DataAccessRule';
import { DataClass } from '../models/DataClass';
import { DataClassesDetails } from '../models/DataClassesDetails';
import { DataClassesFilters } from '../models/DataClassesFilters';
import { DataClassificationEntity } from '../models/DataClassificationEntity';
import { DatabaseDestination } from '../models/DatabaseDestination';
import { DatabaseRecord } from '../models/DatabaseRecord';
import { DeactivateAwsOrganizationResponse } from '../models/DeactivateAwsOrganizationResponse';
import { DeactivateSourceAccountResponse } from '../models/DeactivateSourceAccountResponse';
import { DestinationDetails } from '../models/DestinationDetails';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams';
import { DiscoveryJob } from '../models/DiscoveryJob';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint';
import { EksCluster } from '../models/EksCluster';
import { EksClusterStatus } from '../models/EksClusterStatus';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination';
import { EncryptionKey } from '../models/EncryptionKey';
import { EncryptionKeys } from '../models/EncryptionKeys';
import { Environment } from '../models/Environment';
import { EnvironmentDetails } from '../models/EnvironmentDetails';
import { EnvironmentFilters } from '../models/EnvironmentFilters';
import { EonAccount } from '../models/EonAccount';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
import { FileExplorerResponse } from '../models/FileExplorerResponse';
import { FilePath } from '../models/FilePath';
import { FileRestoreData } from '../models/FileRestoreData';
import { FileSearchRecord } from '../models/FileSearchRecord';
import { FileSnapshot } from '../models/FileSnapshot';
import { GCSBucket } from '../models/GCSBucket';
import { GCSBuckets } from '../models/GCSBuckets';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse';
import { GcpSubnet } from '../models/GcpSubnet';
import { GcpVmResource } from '../models/GcpVmResource';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties';
import { GenericSnapshotData } from '../models/GenericSnapshotData';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse';
import { GetResourceResponse } from '../models/GetResourceResponse';
import { GetScanningApp200Response } from '../models/GetScanningApp200Response';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse';
import { GroupToRoleMapping } from '../models/GroupToRoleMapping';
import { IDs } from '../models/IDs';
import { IdFilters } from '../models/IdFilters';
import { Identifier } from '../models/Identifier';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime';
import { InfectedDateSize } from '../models/InfectedDateSize';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse';
import { InitAuthInput } from '../models/InitAuthInput';
import { Initiator } from '../models/Initiator';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk';
import { InventoryResource } from '../models/InventoryResource';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume';
import { InventoryVault } from '../models/InventoryVault';
import { InventoryVolume } from '../models/InventoryVolume';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments';
import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails';
import { JobStatus } from '../models/JobStatus';
import { JobStatusFilters } from '../models/JobStatusFilters';
import { KubeAccessStatus } from '../models/KubeAccessStatus';
import { KubernetesAccessMode } from '../models/KubernetesAccessMode';
import { ListAccountsResponse } from '../models/ListAccountsResponse';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse';
import { ListAwsOrganizationsResponse } from '../models/ListAwsOrganizationsResponse';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse';
import { ListControlsResponse } from '../models/ListControlsResponse';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse';
import { ListInventoryRequest } from '../models/ListInventoryRequest';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse';
import { ListProjectsResponse } from '../models/ListProjectsResponse';
import { ListResourcesResponse } from '../models/ListResourcesResponse';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner';
import { ListUsersResponse } from '../models/ListUsersResponse';
import { MaxRetentionRule } from '../models/MaxRetentionRule';
import { Message } from '../models/Message';
import { MinRetentionRule, MinRetentionRuleFrequencyEnum } from '../models/MinRetentionRule';
import { ModelError } from '../models/ModelError';
import { Notification } from '../models/Notification';
import { NotificationArguments } from '../models/NotificationArguments';
import { NotificationArgumentsRestoreJobFailed } from '../models/NotificationArgumentsRestoreJobFailed';
import { NotificationArgumentsRestoreJobSucceeded } from '../models/NotificationArgumentsRestoreJobSucceeded';
import { NotificationPolicy, NotificationPolicyTypeEnum } from '../models/NotificationPolicy';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk';
import { NotificationStatus } from '../models/NotificationStatus';
import { NotificationType } from '../models/NotificationType';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination';
import { ObjectStoreExclusionRule, ObjectStoreExclusionRuleStoreTypeEnum } from '../models/ObjectStoreExclusionRule';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup';
import { OperationIdFilters } from '../models/OperationIdFilters';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse';
import { Pagination } from '../models/Pagination';
import { PartialRestoreData } from '../models/PartialRestoreData';
import { PartialRestoreType } from '../models/PartialRestoreType';
import { Path } from '../models/Path';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse';
import { PathType } from '../models/PathType';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties';
import { Preferences } from '../models/Preferences';
import { Project } from '../models/Project';
import { Provider } from '../models/Provider';
import { QueryDBRequest } from '../models/QueryDBRequest';
import { QueryDBResponse } from '../models/QueryDBResponse';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination';
import { QueryDBRestoreDestinationType } from '../models/QueryDBRestoreDestinationType';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse';
import { QueryDBStatus } from '../models/QueryDBStatus';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments';
import { RansomwareSnapshotNotificationArguments } from '../models/RansomwareSnapshotNotificationArguments';
import { RegisterInput } from '../models/RegisterInput';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken';
import { RegisterResponse } from '../models/RegisterResponse';
import { RequestDetails } from '../models/RequestDetails';
import { ResourceDetails } from '../models/ResourceDetails';
import { ResourceIdFilters } from '../models/ResourceIdFilters';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers';
import { ResourceNameFilters } from '../models/ResourceNameFilters';
import { ResourceProperties } from '../models/ResourceProperties';
import { ResourceSnapshot } from '../models/ResourceSnapshot';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties';
import { ResourceSortField } from '../models/ResourceSortField';
import { ResourceTag } from '../models/ResourceTag';
import { ResourceType } from '../models/ResourceType';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { RestoreAccount } from '../models/RestoreAccount';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig';
import { RestoreAzureDiskInput } from '../models/RestoreAzureDiskInput';
import { RestoreAzureMssqlInput } from '../models/RestoreAzureMssqlInput';
import { RestoreAzureVMInput } from '../models/RestoreAzureVMInput';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest';
import { RestoreDynamoDBTableInput } from '../models/RestoreDynamoDBTableInput';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig';
import { RestoreGcpCloudSqlInput } from '../models/RestoreGcpCloudSqlInput';
import { RestoreGcpDiskInput } from '../models/RestoreGcpDiskInput';
import { RestoreGcpVMInput } from '../models/RestoreGcpVMInput';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput';
import { RestoreImageInput } from '../models/RestoreImageInput';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput';
import { RestoreInstanceInput } from '../models/RestoreInstanceInput';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput';
import { RestoreJob } from '../models/RestoreJob';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse';
import { RestoreJobSortField } from '../models/RestoreJobSortField';
import { RestoreJobType } from '../models/RestoreJobType';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest';
import { Role } from '../models/Role';
import { RolesResponse } from '../models/RolesResponse';
import { S3Bucket } from '../models/S3Bucket';
import { S3Buckets } from '../models/S3Buckets';
import { S3RestoreDestination } from '../models/S3RestoreDestination';
import { S3RestoreTarget } from '../models/S3RestoreTarget';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest';
import { ScanJob } from '../models/ScanJob';
import { ScheduleMode } from '../models/ScheduleMode';
import { SchemaRecord } from '../models/SchemaRecord';
import { SearchDBResponse } from '../models/SearchDBResponse';
import { SearchFilesResponse } from '../models/SearchFilesResponse';
import { SearchInput } from '../models/SearchInput';
import { SecurityAssignmentStatus } from '../models/SecurityAssignmentStatus';
import { SecurityInformation } from '../models/SecurityInformation';
import { SecurityPlan } from '../models/SecurityPlan';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse';
import { SecurityScan, SecurityScanConclusionEnum } from '../models/SecurityScan';
import { SecurityScanExample, SecurityScanExampleTypeEnum } from '../models/SecurityScanExample';
import { SecurityScanResult, SecurityScanResultEvidenceTypeEnum } from '../models/SecurityScanResult';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse';
import { SecuritySummary } from '../models/SecuritySummary';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails';
import { Severity } from '../models/Severity';
import { SeverityFilters } from '../models/SeverityFilters';
import { Snapshot } from '../models/Snapshot';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions';
import { SnapshotLocation } from '../models/SnapshotLocation';
import { SnapshotStatus } from '../models/SnapshotStatus';
import { SnapshotStatusFilters } from '../models/SnapshotStatusFilters';
import { SnapshotStorage } from '../models/SnapshotStorage';
import { SortBackupJobBy } from '../models/SortBackupJobBy';
import { SortLogsBy, SortLogsByFieldEnum } from '../models/SortLogsBy';
import { SortOrder } from '../models/SortOrder';
import { SortResourceBy } from '../models/SortResourceBy';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy';
import { SourceAccount } from '../models/SourceAccount';
import { SourceAccountConfiguration } from '../models/SourceAccountConfiguration';
import { SourceAccountConfigurationUpdateInput } from '../models/SourceAccountConfigurationUpdateInput';
import { SourceRegionFilters } from '../models/SourceRegionFilters';
import { SourceStorage } from '../models/SourceStorage';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings';
import { StatusCodeFilters } from '../models/StatusCodeFilters';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget';
import { SubnetFilters } from '../models/SubnetFilters';
import { TableRecord } from '../models/TableRecord';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters';
import { TagKeysFilters } from '../models/TagKeysFilters';
import { TokenResponse } from '../models/TokenResponse';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord';
import { UpdateAccountInput } from '../models/UpdateAccountInput';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest';
import { UpdateBackupVaultNameInput } from '../models/UpdateBackupVaultNameInput';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest';
import { UpdateRoleInput } from '../models/UpdateRoleInput';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest';
import { UpdateUserInput } from '../models/UpdateUserInput';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest';
import { User } from '../models/User';
import { UserIdFilters } from '../models/UserIdFilters';
import { VaultFilters } from '../models/VaultFilters';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments';
import { Viewer } from '../models/Viewer';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint';
import { VisualizationLabel } from '../models/VisualizationLabel';
import { VolumeSettings } from '../models/VolumeSettings';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters';

/* tslint:disable:no-unused-variable */
let primitives = [
          "string",
          "boolean",
          "double",
          "integer",
          "long",
          "float",
          "number",
          "any"
         ];

let enumsMap: Set<string> = new Set<string>([
  "AccountState",
  "AuditLogAction",
  "AzureConnectAccountRequestAccountTypeEnum",
  "AzureConnectAccountTerraformRequestAccountTypeEnum",
  "AzureMarketplaceWebhookInputActionEnum",
  "AzureMarketplaceWebhookInputStatusEnum",
  "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
  "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
  "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
  "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
  "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
  "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
  "AzureOnboardingRequestAccountTypeEnum",
  "BackupJobSortField",
  "BackupJobType",
  "BackupPolicyType",
  "BackupStatus",
  "CloudAccountType",
  "ConditionOperatorEnum",
  "DBSnapshotType",
  "DataClass",
  "EksClusterStatus",
  "Environment",
  "JobStatus",
  "KubeAccessStatus",
  "KubernetesAccessMode",
  "MinRetentionRuleFrequencyEnum",
  "NotificationPolicyTypeEnum",
  "NotificationStatus",
  "NotificationType",
  "ObjectStoreExclusionRuleStoreTypeEnum",
  "PartialRestoreType",
  "PathType",
  "Provider",
  "QueryDBRestoreDestinationType",
  "QueryDBStatus",
  "ResourceSortField",
  "ResourceType",
  "RestoreJobSortField",
  "RestoreJobType",
  "ScheduleMode",
  "SecurityAssignmentStatus",
  "SecurityScanConclusionEnum",
  "SecurityScanExampleTypeEnum",
  "SecurityScanResultEvidenceTypeEnum",
  "Severity",
  "SnapshotStatus",
  "SortLogsByFieldEnum",
  "SortOrder",
]);

let typeMap: {[index: string]: any} = {
  "Account": Account,
  "AccountIdFilters": AccountIdFilters,
  "AccountUpdateInput": AccountUpdateInput,
  "AccountsResponse": AccountsResponse,
  "ActionFilters": ActionFilters,
  "ActivateAwsOrganizationResponse": ActivateAwsOrganizationResponse,
  "ActivateSourceAccountResponse": ActivateSourceAccountResponse,
  "Ami": Ami,
  "AmiBlockDevice": AmiBlockDevice,
  "ApiCredentials": ApiCredentials,
  "ApiCredentialsProperties": ApiCredentialsProperties,
  "App": App,
  "AppFilters": AppFilters,
  "ApplicationOverride": ApplicationOverride,
  "AppsDetails": AppsDetails,
  "AtlasProject": AtlasProject,
  "AtlasProjects": AtlasProjects,
  "AuditLog": AuditLog,
  "AuditLogEntitiesInner": AuditLogEntitiesInner,
  "AuditLogFilterConditions": AuditLogFilterConditions,
  "AuthParams": AuthParams,
  "AuthResponse": AuthResponse,
  "AwsDatabaseDestination": AwsDatabaseDestination,
  "AwsDynamoDBDestination": AwsDynamoDBDestination,
  "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
  "AwsEc2Resource": AwsEc2Resource,
  "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
  "AwsEksNamespaceResource": AwsEksNamespaceResource,
  "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
  "AwsOrganization": AwsOrganization,
  "AwsRdsResource": AwsRdsResource,
  "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
  "AzureAksNamespaceResource": AzureAksNamespaceResource,
  "AzureAppIdResponse": AzureAppIdResponse,
  "AzureConnectAccountRequest": AzureConnectAccountRequest,
  "AzureConnectAccountTerraformRequest": AzureConnectAccountTerraformRequest,
  "AzureConnectionIdResponse": AzureConnectionIdResponse,
  "AzureConsentUrlResponse": AzureConsentUrlResponse,
  "AzureDiskRestoreData": AzureDiskRestoreData,
  "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
  "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
  "AzureManagementGroup": AzureManagementGroup,
  "AzureManagementGroups": AzureManagementGroups,
  "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
  "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
  "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
  "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
  "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
  "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
  "AzureOnboardingRequest": AzureOnboardingRequest,
  "AzureOnboardingStatus": AzureOnboardingStatus,
  "AzureOnboardingStatusResponse": AzureOnboardingStatusResponse,
  "AzureResourceGroup": AzureResourceGroup,
  "AzureResourceGroups": AzureResourceGroups,
  "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
  "AzureStorageAccount": AzureStorageAccount,
  "AzureStorageAccounts": AzureStorageAccounts,
  "AzureSubscription": AzureSubscription,
  "AzureTenant": AzureTenant,
  "AzureVmDisk": AzureVmDisk,
  "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
  "BackedUpByResourceType": BackedUpByResourceType,
  "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
  "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
  "BackupControlViolations": BackupControlViolations,
  "BackupJob": BackupJob,
  "BackupJobResponse": BackupJobResponse,
  "BackupJobsFilterConditions": BackupJobsFilterConditions,
  "BackupPoliciesFilters": BackupPoliciesFilters,
  "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
  "BackupPolicy": BackupPolicy,
  "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
  "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
  "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
  "BackupRegionsFilters": BackupRegionsFilters,
  "BackupSchedule": BackupSchedule,
  "BackupStatusFilters": BackupStatusFilters,
  "BackupVault": BackupVault,
  "BatchApplicationOverrides": BatchApplicationOverrides,
  "BatchOperationResponse": BatchOperationResponse,
  "BooleanFilters": BooleanFilters,
  "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
  "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
  "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
  "Classifications": Classifications,
  "CloudAccountConfiguration": CloudAccountConfiguration,
  "CloudAccountConfigurationAwsConfigInner": CloudAccountConfigurationAwsConfigInner,
  "CloudAccountConfigurationAwsSecurityGroup": CloudAccountConfigurationAwsSecurityGroup,
  "CloudAccountConfigurationAwsSubnet": CloudAccountConfigurationAwsSubnet,
  "CloudAccountConfigurationInput": CloudAccountConfigurationInput,
  "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
  "CloudRegion": CloudRegion,
  "CloudResourceConfiguration": CloudResourceConfiguration,
  "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
  "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
  "ClusterNameFilters": ClusterNameFilters,
  "ColumnMetadata": ColumnMetadata,
  "Condition": Condition,
  "ConnectAwsOrganizationRequest": ConnectAwsOrganizationRequest,
  "ConnectAwsOrganizationResponse": ConnectAwsOrganizationResponse,
  "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
  "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
  "Control": Control,
  "ControlRules": ControlRules,
  "ControlViolation": ControlViolation,
  "ControlViolations": ControlViolations,
  "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
  "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
  "ControlsFilters": ControlsFilters,
  "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
  "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
  "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
  "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
  "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
  "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
  "CreateAccountInput": CreateAccountInput,
  "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
  "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
  "CreateBackupJobInput": CreateBackupJobInput,
  "CreateBackupVaultInput": CreateBackupVaultInput,
  "CreatePolicyInput": CreatePolicyInput,
  "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
  "CreateProjectInput": CreateProjectInput,
  "CreateRoleInput": CreateRoleInput,
  "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
  "CreateScanJobInput": CreateScanJobInput,
  "CreateScanningApp200Response": CreateScanningApp200Response,
  "CreateUserInput": CreateUserInput,
  "CustomTagsInner": CustomTagsInner,
  "DBResourceMetadata": DBResourceMetadata,
  "DBServerRecord": DBServerRecord,
  "DBSnapshotMetadata": DBSnapshotMetadata,
  "DailySnapshotData": DailySnapshotData,
  "DailyStorageSummaries": DailyStorageSummaries,
  "DailyStorageSummary": DailyStorageSummary,
  "DataAccessRule": DataAccessRule,
  "DataClassesDetails": DataClassesDetails,
  "DataClassesFilters": DataClassesFilters,
  "DataClassificationEntity": DataClassificationEntity,
  "DatabaseDestination": DatabaseDestination,
  "DatabaseRecord": DatabaseRecord,
  "DeactivateAwsOrganizationResponse": DeactivateAwsOrganizationResponse,
  "DeactivateSourceAccountResponse": DeactivateSourceAccountResponse,
  "DestinationDetails": DestinationDetails,
  "DestinationProviderAttributes": DestinationProviderAttributes,
  "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
  "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
  "DiscoveryInvokeParams": DiscoveryInvokeParams,
  "DiscoveryJob": DiscoveryJob,
  "DiscoveryStatusResponse": DiscoveryStatusResponse,
  "DriftProtectionPolicy": DriftProtectionPolicy,
  "DriftProtectionSummary": DriftProtectionSummary,
  "DriftProtectionTimePoint": DriftProtectionTimePoint,
  "EksCluster": EksCluster,
  "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
  "EncryptionKey": EncryptionKey,
  "EncryptionKeys": EncryptionKeys,
  "EnvironmentDetails": EnvironmentDetails,
  "EnvironmentFilters": EnvironmentFilters,
  "EonAccount": EonAccount,
  "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
  "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
  "FileExplorerResponse": FileExplorerResponse,
  "FilePath": FilePath,
  "FileRestoreData": FileRestoreData,
  "FileSearchRecord": FileSearchRecord,
  "FileSnapshot": FileSnapshot,
  "GCSBucket": GCSBucket,
  "GCSBuckets": GCSBuckets,
  "GCSRestoreDestination": GCSRestoreDestination,
  "GCSRestoreTarget": GCSRestoreTarget,
  "GcpCloudSqlResource": GcpCloudSqlResource,
  "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
  "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
  "GcpDiskRestoreData": GcpDiskRestoreData,
  "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
  "GcpDiskTypesResponse": GcpDiskTypesResponse,
  "GcpEncryptionKey": GcpEncryptionKey,
  "GcpEncryptionKeys": GcpEncryptionKeys,
  "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
  "GcpMachineTypesResponse": GcpMachineTypesResponse,
  "GcpSubnet": GcpSubnet,
  "GcpVmResource": GcpVmResource,
  "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
  "GenericSnapshotData": GenericSnapshotData,
  "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
  "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
  "GetResourceResponse": GetResourceResponse,
  "GetScanningApp200Response": GetScanningApp200Response,
  "GetSnapshotResponse": GetSnapshotResponse,
  "GroupToRoleMapping": GroupToRoleMapping,
  "IDs": IDs,
  "IdFilters": IdFilters,
  "Identifier": Identifier,
  "InfectedDataByClassification": InfectedDataByClassification,
  "InfectedDataClassificationSize": InfectedDataClassificationSize,
  "InfectedDataOverTime": InfectedDataOverTime,
  "InfectedDateSize": InfectedDateSize,
  "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
  "InitAuthInput": InitAuthInput,
  "Initiator": Initiator,
  "InitiatorNameFilters": InitiatorNameFilters,
  "InventoryFilterConditions": InventoryFilterConditions,
  "InventoryGcpDisk": InventoryGcpDisk,
  "InventoryResource": InventoryResource,
  "InventoryResourceMetadata": InventoryResourceMetadata,
  "InventorySnapshotVolume": InventorySnapshotVolume,
  "InventoryVault": InventoryVault,
  "InventoryVolume": InventoryVolume,
  "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
  "JobExecutionDetails": JobExecutionDetails,
  "JobSnapshotDetails": JobSnapshotDetails,
  "JobStatusFilters": JobStatusFilters,
  "ListAccountsResponse": ListAccountsResponse,
  "ListApiCredentialsResponse": ListApiCredentialsResponse,
  "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
  "ListAuditLogRequest": ListAuditLogRequest,
  "ListAuditLogResponse": ListAuditLogResponse,
  "ListAuditLogsResponse": ListAuditLogsResponse,
  "ListAwsOrganizationsResponse": ListAwsOrganizationsResponse,
  "ListAzureRegions200Response": ListAzureRegions200Response,
  "ListAzureSKUs200Response": ListAzureSKUs200Response,
  "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
  "ListAzureSKUsRequest": ListAzureSKUsRequest,
  "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
  "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
  "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
  "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
  "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
  "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
  "ListBackupJobsRequest": ListBackupJobsRequest,
  "ListBackupJobsResponse": ListBackupJobsResponse,
  "ListBackupPolicyResponse": ListBackupPolicyResponse,
  "ListBackupVaultResponse": ListBackupVaultResponse,
  "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
  "ListControlViolationsResponse": ListControlViolationsResponse,
  "ListControlsResponse": ListControlsResponse,
  "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
  "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
  "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
  "ListEksClustersResponse": ListEksClustersResponse,
  "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
  "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
  "ListInstanceTypesResponse": ListInstanceTypesResponse,
  "ListInventoryAppsResponse": ListInventoryAppsResponse,
  "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
  "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
  "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
  "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
  "ListInventoryRequest": ListInventoryRequest,
  "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
  "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
  "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
  "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
  "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
  "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
  "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
  "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
  "ListInventoryTagsResponse": ListInventoryTagsResponse,
  "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
  "ListNotificationsResponse": ListNotificationsResponse,
  "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
  "ListProjectsResponse": ListProjectsResponse,
  "ListResourcesResponse": ListResourcesResponse,
  "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
  "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
  "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
  "ListRestoreJobsRequest": ListRestoreJobsRequest,
  "ListRestoreJobsResponse": ListRestoreJobsResponse,
  "ListScanJobsRequest": ListScanJobsRequest,
  "ListScanJobsResponse": ListScanJobsResponse,
  "ListSubnetsResponse": ListSubnetsResponse,
  "ListSubnetsResponseV2": ListSubnetsResponseV2,
  "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
  "ListUsersResponse": ListUsersResponse,
  "MaxRetentionRule": MaxRetentionRule,
  "Message": Message,
  "MinRetentionRule": MinRetentionRule,
  "ModelError": ModelError,
  "Notification": Notification,
  "NotificationArguments": NotificationArguments,
  "NotificationArgumentsRestoreJobFailed": NotificationArgumentsRestoreJobFailed,
  "NotificationArgumentsRestoreJobSucceeded": NotificationArgumentsRestoreJobSucceeded,
  "NotificationPolicy": NotificationPolicy,
  "NotificationPolicyConfig": NotificationPolicyConfig,
  "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
  "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
  "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
  "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
  "NumberOfCopiesRule": NumberOfCopiesRule,
  "ObjectStorageDestination": ObjectStorageDestination,
  "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
  "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
  "OperationIdFilters": OperationIdFilters,
  "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
  "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
  "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
  "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
  "Pagination": Pagination,
  "PartialRestoreData": PartialRestoreData,
  "Path": Path,
  "PathSnapshotsRequest": PathSnapshotsRequest,
  "PathSnapshotsResponse": PathSnapshotsResponse,
  "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
  "Preferences": Preferences,
  "Project": Project,
  "QueryDBRequest": QueryDBRequest,
  "QueryDBResponse": QueryDBResponse,
  "QueryDBRestoreDestination": QueryDBRestoreDestination,
  "QueryDBResultResponse": QueryDBResultResponse,
  "QueryDBStatusResponse": QueryDBStatusResponse,
  "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
  "RansomwareSnapshotNotificationArguments": RansomwareSnapshotNotificationArguments,
  "RegisterInput": RegisterInput,
  "RegisterInputBillingToken": RegisterInputBillingToken,
  "RegisterResponse": RegisterResponse,
  "RequestDetails": RequestDetails,
  "ResourceDetails": ResourceDetails,
  "ResourceIdFilters": ResourceIdFilters,
  "ResourceIdentifiers": ResourceIdentifiers,
  "ResourceNameFilters": ResourceNameFilters,
  "ResourceProperties": ResourceProperties,
  "ResourceSnapshot": ResourceSnapshot,
  "ResourceSnapshotProperties": ResourceSnapshotProperties,
  "ResourceTag": ResourceTag,
  "ResourceTypeFilters": ResourceTypeFilters,
  "RestoreAccount": RestoreAccount,
  "RestoreAccountRegions": RestoreAccountRegions,
  "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
  "RestoreAvailabilityZones": RestoreAvailabilityZones,
  "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
  "RestoreAzureDiskInput": RestoreAzureDiskInput,
  "RestoreAzureMssqlInput": RestoreAzureMssqlInput,
  "RestoreAzureVMInput": RestoreAzureVMInput,
  "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
  "RestoreBucketRequest": RestoreBucketRequest,
  "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
  "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
  "RestoreDynamoDBTableInput": RestoreDynamoDBTableInput,
  "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
  "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
  "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
  "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
  "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
  "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
  "RestoreFilesRequest": RestoreFilesRequest,
  "RestoreGceDiskConfig": RestoreGceDiskConfig,
  "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
  "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
  "RestoreGcpCloudSqlInput": RestoreGcpCloudSqlInput,
  "RestoreGcpDiskInput": RestoreGcpDiskInput,
  "RestoreGcpVMInput": RestoreGcpVMInput,
  "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
  "RestoreImageImageInput": RestoreImageImageInput,
  "RestoreImageInput": RestoreImageInput,
  "RestoreImageVolumeInput": RestoreImageVolumeInput,
  "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
  "RestoreInstanceImageInput": RestoreInstanceImageInput,
  "RestoreInstanceInput": RestoreInstanceInput,
  "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
  "RestoreJob": RestoreJob,
  "RestoreJobConfiguration": RestoreJobConfiguration,
  "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
  "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
  "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
  "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
  "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
  "RestoreSecurityGroups": RestoreSecurityGroups,
  "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
  "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
  "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
  "Role": Role,
  "RolesResponse": RolesResponse,
  "S3Bucket": S3Bucket,
  "S3Buckets": S3Buckets,
  "S3RestoreDestination": S3RestoreDestination,
  "S3RestoreTarget": S3RestoreTarget,
  "SamlIdentityProvider": SamlIdentityProvider,
  "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
  "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
  "ScanJob": ScanJob,
  "SchemaRecord": SchemaRecord,
  "SearchDBResponse": SearchDBResponse,
  "SearchFilesResponse": SearchFilesResponse,
  "SearchInput": SearchInput,
  "SecurityInformation": SecurityInformation,
  "SecurityPlan": SecurityPlan,
  "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
  "SecurityScan": SecurityScan,
  "SecurityScanExample": SecurityScanExample,
  "SecurityScanResult": SecurityScanResult,
  "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
  "SecuritySummary": SecuritySummary,
  "ServiceProviderDetails": ServiceProviderDetails,
  "SeverityFilters": SeverityFilters,
  "Snapshot": Snapshot,
  "SnapshotFilterConditions": SnapshotFilterConditions,
  "SnapshotLocation": SnapshotLocation,
  "SnapshotStatusFilters": SnapshotStatusFilters,
  "SnapshotStorage": SnapshotStorage,
  "SortBackupJobBy": SortBackupJobBy,
  "SortLogsBy": SortLogsBy,
  "SortResourceBy": SortResourceBy,
  "SortRestoreJobBy": SortRestoreJobBy,
  "SourceAccount": SourceAccount,
  "SourceAccountConfiguration": SourceAccountConfiguration,
  "SourceAccountConfigurationUpdateInput": SourceAccountConfigurationUpdateInput,
  "SourceRegionFilters": SourceRegionFilters,
  "SourceStorage": SourceStorage,
  "SourceStorageBackupStatus": SourceStorageBackupStatus,
  "SsoIntegrationSettings": SsoIntegrationSettings,
  "StatusCodeFilters": StatusCodeFilters,
  "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
  "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
  "SubnetFilters": SubnetFilters,
  "TableRecord": TableRecord,
  "TagKeyValuesFilters": TagKeyValuesFilters,
  "TagKeysFilters": TagKeysFilters,
  "TokenResponse": TokenResponse,
  "UnifiedDBRecord": UnifiedDBRecord,
  "UnifiedDBServerRecord": UnifiedDBServerRecord,
  "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
  "UnifiedSchemaRecord": UnifiedSchemaRecord,
  "UnifiedTableRecord": UnifiedTableRecord,
  "UpdateAccountInput": UpdateAccountInput,
  "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
  "UpdateBackupVaultNameInput": UpdateBackupVaultNameInput,
  "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
  "UpdateControlViolationInput": UpdateControlViolationInput,
  "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
  "UpdateRoleInput": UpdateRoleInput,
  "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
  "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
  "UpdateUserInput": UpdateUserInput,
  "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
  "User": User,
  "UserIdFilters": UserIdFilters,
  "VaultFilters": VaultFilters,
  "VaultNotificationArguments": VaultNotificationArguments,
  "Viewer": Viewer,
  "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
  "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
  "VisualizationHistogramSeries": VisualizationHistogramSeries,
  "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
  "VisualizationLabel": VisualizationLabel,
  "VolumeSettings": VolumeSettings,
  "VpcPropertyFilters": VpcPropertyFilters,
}

export class ObjectSerializer {
  public static findCorrectType(data: any, expectedType: string) {
    if (data == undefined) {
      return expectedType;
    } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
      return expectedType;
    } else if (expectedType === "Date") {
      return expectedType;
    } else {
      if (enumsMap.has(expectedType)) {
        return expectedType;
      }

      if (!typeMap[expectedType]) {
        return expectedType; // w/e we don't know the type
      }

      // Check the discriminator
      let discriminatorProperty = typeMap[expectedType].discriminator;
      if (discriminatorProperty == null) {
        return expectedType; // the type does not have a discriminator. use it.
      } else {
        if (data[discriminatorProperty]) {
          var discriminatorType = data[discriminatorProperty];
          if(typeMap[discriminatorType]){
            return discriminatorType; // use the type given in the discriminator
          } else {
            return expectedType; // discriminator did not map to a type
          }
        } else {
          return expectedType; // discriminator was not present (or an empty string)
        }
      }
    }
  }

  public static serialize(data: any, type: string, format: string) {
    if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
      return data;
    } else if (type.startsWith("Array<", 0)) { 
      let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
      subType = subType.substring(0, subType.length - 1); // Type> => Type
      let transformedData: any[] = [];
      for (let date of data) {
        transformedData.push(ObjectSerializer.serialize(date, subType, format));
      }
      return transformedData;
    } else if (type === "Date") {
      if (format == "date") {
        let month = data.getMonth()+1
        month = month < 10 ? "0" + month.toString() : month.toString()
        let day = data.getDate();
        day = day < 10 ? "0" + day.toString() : day.toString();

        return data.getFullYear() + "-" + month + "-" + day;
      } else {
        return data.toISOString();
      }
    } else {
      if (enumsMap.has(type)) {
        return data;
      }
      if (!typeMap[type]) { // in case we dont know the type
        return data;
      }

      // Get the actual type of this object
      type = this.findCorrectType(data, type);

      // get the map for the correct type.
      let attributeTypes = typeMap[type].getAttributeTypeMap();
      let instance: {[index: string]: any} = {};
      for (let attributeType of attributeTypes) {
        instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
      }
      return instance;
    }
  }

  public static deserialize(data: any, type: string, format: string) {
    // polymorphism may change the actual type.
    type = ObjectSerializer.findCorrectType(data, type);
    if (data == undefined) {
      return data;
    } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
      return data;
    } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
      let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
      subType = subType.substring(0, subType.length - 1); // Type> => Type
      let transformedData: any[] = [];
      for (let date of data) {
        transformedData.push(ObjectSerializer.deserialize(date, subType, format));
      }
      return transformedData;
    } else if (type === "Date") {
      return new Date(data);
    } else {
      if (enumsMap.has(type)) {// is Enum
        return data;
      }

      if (!typeMap[type]) { // dont know the type
        return data;
      }
      let instance = new typeMap[type]();
      let attributeTypes = typeMap[type].getAttributeTypeMap();
      for (let attributeType of attributeTypes) {
        let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
        if (value !== undefined) {
          instance[attributeType.name] = value;
        }
      }
      return instance;
    }
  }

  /**
   * From a list of possible media types, choose the one we can handle best.
   *
   * The order of the given media types does not have any impact on the choice
   * made.
   */
  public static getPreferredMediaType(mediaTypes: Array<string>): string {
    return "application/json";
  }

}
